import React, { useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import { FaTimes, FaCopy, FaCode, FaCss3Alt } from "react-icons/fa";
import "../UIcss/CodeViewer.css";

const CodeViewer = ({ isOpen, onClose, componentName, jsxCode, cssCode }) => {
  if (!isOpen) return null;

  const [activeTab, setActiveTab] = useState("html");
  const [copied, setCopied] = useState(false);

  // Reset states when opening/changing
  React.useEffect(() => {
    setCopied(false);
    setActiveTab("html");
  }, [componentName]);

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const toDisplay = activeTab === "html" ? jsxCode : cssCode;
  const language = activeTab === "html" ? "html" : "css";

  return (
    <div className="code-viewer-overlay" onClick={onClose}>
      <div className="code-viewer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cv-header">
          <h3>
            <span style={{ opacity: 0.5 }}>Viewing:</span> {componentName}
          </h3>
          <div className="cv-actions">
            <button className="cv-close" onClick={onClose} title="Close">
              Close <FaTimes />
            </button>
          </div>
        </div>

        <div className="cv-tabs">
          <button
            className={`cv-tab ${activeTab === "html" ? "active" : ""}`}
            onClick={() => setActiveTab("html")}
          >
            <FaCode style={{ fontSize: "14px" }} /> HTML
          </button>
          <button
            className={`cv-tab ${activeTab === "css" ? "active" : ""}`}
            onClick={() => setActiveTab("css")}
          >
            <FaCss3Alt style={{ fontSize: "14px" }} /> CSS
          </button>
        </div>

        <div className="cv-body" style={{ display: "block" }}>
          <div
            className="code-section"
            style={{ border: "none", borderRadius: 0 }}
          >
            <button
              className="copy-btn"
              onClick={() => handleCopy(toDisplay)}
              style={{ top: "15px", right: "20px" }}
            >
              <FaCopy /> {copied ? "Copied!" : "Copy"}
            </button>
            <SyntaxHighlighter
              language={language}
              style={vscDarkPlus}
              customStyle={{
                margin: 0,
                padding: "20px",
                fontSize: "14px",
                lineHeight: "1.5",
                minHeight: "100%",
                background: "transparent",
              }}
              showLineNumbers={true}
            >
              {toDisplay || ""}
            </SyntaxHighlighter>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodeViewer;
